import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import { useSearchParams } from 'react-router-dom';
import { createWebhookPayload, functionParameters, functionResponse } from './customAPIConfigPopup';
import GlobalPopUp from '../../../../../utility/globalPopUp';
import CreateVariablePopup from '../dataCollections/createVariablePopup';
import GlobalDeletePopup from '../../../../../utility/globalDeletePopup/globalDeletePopup';
import { customVariableDataInterface, functionParameterData, functionResponseData } from '../../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import agent from '../../../../../../services/api';
import EditResponseVarPathPopup from './editResponseVarPathPopup';
import MemoizedRow from './memoizedAssignVariableTableRow';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface AssignVariablesTablePropsGeneric {
    tableData: functionParameterData[] | functionResponseData[],
    payload: functionParameters[] | functionResponse[],
    setPayload: React.Dispatch<React.SetStateAction<createWebhookPayload>>;
    onChangeOfField: (value: customVariableDataInterface | null, ind: number, key: string) => void;
    onChangeOfFallbackValue: (value: string, ind: number) => void;
    onChangeOfFieldVariableTypeForFunctionParameter?: (value: any, ind: number) => void
}
const AssignVariablesTable = (props: AssignVariablesTablePropsGeneric) => {
    const { tableData, payload, onChangeOfField, onChangeOfFallbackValue,
        setPayload, onChangeOfFieldVariableTypeForFunctionParameter
    } = props;
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const flagDataCollectionPopup = useFlowBuilderStore((state) => state.flagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const flagDeleteFieldData = useFlowBuilderStore((state) => state.flagDeleteFieldData)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams()
    let workflow_id = searchParams.get("workflow_id")
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');

    const [flagEditResVarPathPopup, setFlagEditResVarPathPopup] = useState<boolean>(false);
    const [selectedResPayload, setSelectedResPayload] = useState<functionResponse | null>(null);


    const handleDeleteField = async () => {
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
        const res = await agent.deleteChatbotCustomVariable.delete(existingCustomVariablePayload.chatbot_custom_variable_config_id)
        if (res.status) {
            showSuccess("Field Deleted Successfully")
            await GetCustomVariableListApi(workflow_id || "")
        }
        else {
            handleError(res);
        }
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });
    }

    const sortTableData = (tableData: functionParameterData[] | functionResponseData[]) => {
        if (isFunctionParameterTableData(tableData)) {
            return tableData?.sort((a, b) => Number(a.function_parameter_data_id) - Number(b.function_parameter_data_id));
        } else {
            return tableData?.sort((a, b) => Number(a.function_response_data_id) - Number(b.function_response_data_id));
        }
    }

    const isFunctionParameterTableData = (data: functionParameterData[] | functionResponseData[]): data is functionParameterData[] => {
        return data?.length > 0 && 'function_parameter_data_id' in data?.[0];
    }


    return (
        <>
            <TableContainer className={`${globalStyles.boxSizingBorderBox} ${globalStyles.maxWidthFull} ${globalStyles.fullwidth} ${globalStyles.overflowAuto} ${styles.assignVariableTableMaxHeight}`}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>
                                {tableData?.every((row) => "function_parameter_name" in row) ? 'Request Field' : 'Response Field'}
                            </TableCell>
                            {tableData?.every((row) => "function_parameter_name" in row) &&
                                <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Variable Type</TableCell>}
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Variable</TableCell>
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Fallback Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                            {sortTableData(tableData)?.map((parameter: functionParameterData | functionResponseData, ind: number) => {
                                return (
                                    <MemoizedRow payload={payload} ind={ind} parameter={parameter} onChangeOfField={onChangeOfField} onChangeOfFallbackValue={onChangeOfFallbackValue} setFlagEditResVarPathPopup={setFlagEditResVarPathPopup} setSelectedResPayload={setSelectedResPayload} onChangeOfFieldVariableTypeForFunctionParameter={onChangeOfFieldVariableTypeForFunctionParameter} />
                                );
                            })}
                        </>
                    </TableBody>
                </Table>
            </TableContainer>

            {flagDataCollectionPopup &&
                <GlobalPopUp
                    open={flagDataCollectionPopup}
                    onClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                    handleClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                >
                    <CreateVariablePopup />
                </GlobalPopUp>
            }
            {flagDeleteFieldData &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to delete ${existingCustomVariablePayload.chatbot_custom_variable_name} field`}
                    open={flagDeleteFieldData}
                    onClose={() => { setFlagDeleteData(false) }}
                    onDelete={() => {
                        handleDeleteField()
                        setFlagDeleteData(false)
                    }}
                />
            }
            {flagEditResVarPathPopup &&
                <GlobalPopUp
                    open={flagEditResVarPathPopup}
                    onClose={() => { setFlagEditResVarPathPopup(false); setSelectedResPayload(null); }}
                    handleClose={() => { setFlagEditResVarPathPopup(false); setSelectedResPayload(null); }}
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                >
                    <EditResponseVarPathPopup
                        selectedResPayload={selectedResPayload as functionResponse}
                        setSelectedResPayload={setSelectedResPayload}
                        setFlagEditResVarPathPopup={setFlagEditResVarPathPopup}
                        setPayload={setPayload}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default React.memo(AssignVariablesTable) as typeof AssignVariablesTable
